import type { IconSvgObject } from './types';

const ArrowMoveUpRightIcon: IconSvgObject = [
  ["path", { d: "M17 3L20 6L17 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 21V8.00012C4 6.89556 4.89542 6.00013 5.99998 6.00012L20 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowMoveUpRightIcon;
